import React from 'react';
import HTMLReactParser from 'html-react-parser';
import classNames from 'classnames';
import get from 'lodash.get';
import find from 'lodash.find';

/**
 * Try to calculate the table height assuming each row is 53px
 * @param {*} html
 * @param rowHeightInPxs
 */
export const calculateHeight = (html, rowHeightInPxs = 55) => {
  const extraNumberOfRows = 2; // To give extra space for margin bottom and for rowless header.
  let numberOfRows = 0;
  if (!React.isValidElement(html)) {
    // Make sure tbody exists in table and extract it to get Rows only from tbody.
    const tbodyRegex = /tbody([\s\S]*?)tbody/g;
    const tbodyHtml = tbodyRegex.exec(html);
    const htmlToMatch = tbodyHtml ? tbodyHtml[0] : html;

    const rowsRegex = /<tr/g;
    numberOfRows = htmlToMatch.match(rowsRegex).length;
  } else {
    const tbody = Array.isArray(html.props.children) ? find(html.props.children, { type: 'tbody' }) : html.props.children;
    numberOfRows = Array.isArray(tbody.props.children) ? tbody.props.children.length : 0;
  }
  return (numberOfRows + extraNumberOfRows) * rowHeightInPxs;
};

/**
 * Clean table from invalid attributes.
 * @param {*} html
 */
export const ampEnhanceTable = (children) => {
  const childrenProps = children;

  const updatedChildren = React.Children.map(childrenProps, (child) => {
    if (child.type === 'table' && child.props.xmlns) {
      const childProps = {
        xmlns: undefined,
      };
      return React.cloneElement(child, childProps);
    }

    if (typeof child.type === 'function' && child.props.html && child.props.html.indexOf('xmlns') > -1) {
      const regex = /xmlns=".+?"/gm;
      const htmlTable = child.props.html.replace(regex, '');
      const el = HTMLReactParser(htmlTable);
      return el;
    }

    return child;
  });

  return updatedChildren;
};

/**
 * Renders the amp markup for the component. We DO not use the arrow style so that we can have access to this.
 */
function renderAmp() {
  const {
    loadStyles,
    extraClassNames,
    children,
    ampRowHeight,
    context: { cssPrefix },
  } = this.props; // eslint-disable-line

  // Enhance table to add tablesaw attributes
  const enhancedTable = ampEnhanceTable(children); // eslint-disable-line

  // HTML could be React Element or html raw from HTMLSafe
  const html = get(children, 'props.html', children);

  return (
    <amp-carousel
      height={calculateHeight(html, ampRowHeight)}
      width="auto"
      layout="fixed-height"
      type="carousel"
    >
      <div
        className={
          classNames({
            [`${cssPrefix}__table`]: loadStyles,
            ...extraClassNames,
          })
        }
      >
        {enhancedTable}
      </div>
    </amp-carousel>
  );
}

export default renderAmp;
